<template>
  <div>
    <!-- 标签匹配 -->
    <el-dialog title="标签匹配" :close-on-click-modal="false" :visible.sync="dialogVisible" width="380px" center>
      <div class="content" v-if="detail.fba_match_notice != false">
        <p v-for="( item, index ) in detail.fba_match_notice" :key="index">
          {{ item }}
        </p>
      </div>
      <span slot="footer" class="dialog-footer">

        <!-- 保存 -->
        <el-button type="primary" @click="dialogVisible = false">{{
          $t("message.ok")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      detail: (state) => state.porderDetail.detail,
    }),
  },
  data() {
    return {
      dialogVisible: false
    };
  },
  methods: {


  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  p {
    margin-bottom: 10px;
  }
}
</style>